module.exports = __webpack_public_path__ + "static/media/left_side_picture.3fff8a20.jpg";